import React, { useState } from 'react';
import styles from './mediaPlayer.module.css'
/**
 * @typedef {object} Props
 * @property {string} fileType Media file type
 * @property {string} url Media AWS url
 */

/**
 * @param {Props} props
 */
const MediaPlayer = ({ fileType, url }) => {
  if (fileType === 'pdf') return

  return (
    <div className={styles['media-container']}>
      {
        url && (
          <div className={styles['player-wrapper']}>
            {fileType === 'image' && (
              <img src={url} alt='Preview' className={styles['media-element']} />
            )}

            {fileType === 'video' && (
              <video controls className={styles['media-element']}>
                <source src={url} type='video/mp4' />
                Tu navegador no soporta videos.
              </video>
            )}

            {fileType.includes('audio') && (
              <audio controls className={styles['media-element-mp3']}>
                <source src={url} type='audio/mpeg' />
                Tu navegador no soporta audio.
              </audio>
            )}
          </div>
        )
      }
    </div >
  );
};

export default MediaPlayer;